import React, { Component } from 'react'
import styles from './styles'
import misc from 'utils/misc'
import { aRecords, aUsers, aProjects, aTasks } from 'utils/aUtils'
import co from 'co'

export default class ExportRecordForm extends Component {
  constructor (props, context) {
    super(props, context)
    this.clearState = () => this.setState({ start: '', end: '', notice: '' })
    this.onStartChange = e => this.setState({ start: e.target.value })
    this.onEndChange = e => this.setState({ end: e.target.value })
    this.exportCSV = ::this.exportCSV
    this.handleSubmit = ::this.handleSubmit
  }

  state = {
    start: '',
    end: '',
    notice: '',
  };

  handleSubmit () {
    const { start, end } = this.state
    if (!misc.isValidDateString(start) || !misc.isValidDateString(end)) {
      this.setState({ notice: '錯誤日期格式' })
      return
    }
    this.setState({ notice: '' })

    const _this = this
    co(function*() {
      const users = yield aUsers.find()
      const userNames = misc.getDict(users, 'name')
      const projects = yield aProjects.find()
      const projectNames = misc.getDict(projects, 'name')
      const tasks = yield aTasks.find()
      const taskNames = misc.getDict(tasks, 'name')
      const allRecords = yield aRecords.findRange(misc.getDay(start), misc.getDay(end))
      _this.exportCSV(allRecords, userNames, projectNames, taskNames, start, end)
      _this.clearState()
    }).catch(misc.onError)
  }

  exportCSV (records, userNames, projectNames, taskNames, start, end) {
    let csv = '\uFEFF人名,日期,星期,專案名稱,內容代碼,正常,加班,加班時段,交通,交通時段,註解\n'
    const wdName = ['日', '一', '二', '三', '四', '五', '六']
    records.forEach(record => {
      const { userId, projectId, taskId, nTime, note, oSegments, tSegments = [], dateString } = record
      csv += `${userNames[userId]},`
      csv += `${dateString},`
      csv += `${wdName[misc.getWeekDay(record)]},`
      csv += `${projectNames[projectId]},`
      csv += `${taskNames[taskId]},`
      csv += `${(nTime / 2.0).toFixed(1)},`
      csv += `${(misc.getOTime(record) / 2.0).toFixed(1)},`
      oSegments.forEach(seg => {
        csv += `${misc.getTimeStr(seg.start)} ~ ${misc.getTimeStr(seg.end)} `
      })
      csv += ','
      csv += `${(misc.getTTime(record) / 2.0).toFixed(1)},`
      tSegments.forEach(seg => {
        csv += `${misc.getTimeStr(seg.start)} ~ ${misc.getTimeStr(seg.end)} `
      })
      csv += ','
      let processedNote = ''
      if (note) {
        processedNote = note.replace('"', '""')
      }
      csv += `"${processedNote}"\n`
    })

    misc.saveCSV(`${start}_${end}_工時表.csv`, csv)
  }

  render () {
    return (
      <div className={styles.recordExportForm}>
        <input
          className={styles.dateInput}
          placeholder="開始日期(xxxx-x-x)"
          value={this.state.start}
          onChange={this.onStartChange}
        />
        <input
          className={styles.dateInput}
          placeholder="結束日期(xxxx-x-x)"
          value={this.state.end}
          onChange={this.onEndChange}
        />
        <div className={styles.submit}>
          <input type="submit" value="匯出CSV" onClick={this.handleSubmit} />
        </div>
        <div className={styles.notice}>{this.state.notice}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/recordExportForm/index.jsx